import React, { Fragment } from "react";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import TrashCanOutline from "mdi-material-ui/TrashCanOutline";

const ModalDeleteComment = ({ deleteCommentModal, setDeleteCommentModal, handleCommentDelete }) => {
  return (
    <Fragment>
      <Dialog
        open={deleteCommentModal.visible}
        onClose={() => setDeleteCommentModal({ visible: false })}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        PaperProps={{ className: "sp-modal__paper" }}
      >
        <DialogContent className="sp-modal">
          <div className="sp-modal__head">
            <span className="sp-modal__icon sp-modal__icon--danger">
              <TrashCanOutline />
            </span>
            <h2 id="alert-dialog-title" className="sp-modal__title">
              Apagar comentário
            </h2>
          </div>
          <div id="alert-dialog-description" className="sp-modal__body">
            Tens a certeza que queres apagar o teu comentário?
          </div>
        </DialogContent>
        <DialogActions className="sp-modal__actions">
          <button
            type="button"
            className="sp-modal__btn sp-modal__btn--ghost"
            onClick={() => setDeleteCommentModal({ visible: false })}
          >
            Não
          </button>
          <button
            type="button"
            className="sp-modal__btn sp-modal__btn--danger"
            onClick={() => handleCommentDelete(deleteCommentModal.id)}
          >
            Sim, confirmo!
          </button>
        </DialogActions>
      </Dialog>
    </Fragment>
  );
};

export default ModalDeleteComment;
